import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { UnsubscribeGroupEnum } from '@rsmus/ecp-communicationservice'
import type { RootState } from '..'

// Define a type for the slice state
interface EmailSubscriptionState {
  paymentRemindersSubscription: boolean
  paymentUpdatesSubscription: boolean
  subscriptionErrors: UnsubscribeGroupEnum[]
}

// Define the initial state using that type
const initialState: EmailSubscriptionState = {
  paymentRemindersSubscription: true,
  paymentUpdatesSubscription: true,
  subscriptionErrors: [],
}

export const emailSubscriptionSlice = createSlice({
  name: 'emailSubscription',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    setPaymentRemindersSubscription: (
      state,
      action: PayloadAction<boolean>,
    ) => {
      state.paymentRemindersSubscription = action.payload
    },
    setPaymentUpdatesSubscription: (state, action: PayloadAction<boolean>) => {
      state.paymentUpdatesSubscription = action.payload
    },
    setSubscriptionErrors: (
      state,
      action: PayloadAction<UnsubscribeGroupEnum[]>,
    ) => {
      state.subscriptionErrors = action.payload
    },
  },
})

export const { setPaymentRemindersSubscription } =
  emailSubscriptionSlice.actions
export const getPaymentRemindersSubscription = (state: RootState) =>
  state.emailSubscription.paymentRemindersSubscription

export const { setPaymentUpdatesSubscription } = emailSubscriptionSlice.actions
export const getPaymentUpdatesSubscription = (state: RootState) =>
  state.emailSubscription.paymentUpdatesSubscription

export const { setSubscriptionErrors } = emailSubscriptionSlice.actions
export const getSubscriptionErrors = (state: RootState) =>
  state.emailSubscription.subscriptionErrors
